import { render } from "./TagSearch.vue?vue&type=template&id=db6b3686&scoped=true"
import script from "./TagSearch.vue?vue&type=script&lang=js"
export * from "./TagSearch.vue?vue&type=script&lang=js"

import "./TagSearch.vue?vue&type=style&index=0&id=db6b3686&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-db6b3686"

export default script